<template>
  <div class="bundle-quantity-control flex w-full">
    <PlusMinusInput
      v-if="quantity > 0"
      v-model="quantity"
      :sku="sku"
      :min="0"
      :max="store.MAX_SIZE"
      :increase-disabled="store.quantityAtMaximum"
      :readonly="false"
      class="grow rounded-sm w-full"
    />
    <button
      v-else
      :disabled="store.quantityAtMaximum"
      class="button +green w-full"
      data-gtm-action="add to box"
      :data-gtm-label="title"
      @click.prevent.stop="handleClick"
    >
      {{ store.quantityAtMaximum ? $t('bundler.your_box_is_full') : $t('action.add_to_box') }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useFueled } from '@/services/fueled'
import { useBundleStore } from '@/stores'
import { useAmplitude } from '@/services/amplitude'
import { PlusMinusInput } from '@oatsovernight/storybook'
import { clampToRemainingSlots } from '@/utils/bundle'
// import { useToastStore } from '@/plugins/toast'

export interface Props {
  productId?: number
  productKey: string
  title: string
  sku?: string
}

// const { alert } = useToastStore()
const { productClicked } = useFueled()
const store = useBundleStore()
const props = defineProps<Props>()
const quantity = computed({
  get: () => store.selection[props.productKey] || 0,
  set: (value: number) => {
    const currentQty = store.selection[props.productKey] || 0
    const clamped = clampToRemainingSlots(value, currentQty, store.totalQuantity, store.MAX_SIZE)
    store.updateQuantity(props.productKey, clamped)
  }
})

const { trackBundle } = useAmplitude()

const handleClick = async () => {
  quantity.value = 1
  if (props.productId) {
    productClicked(props.productId)
    await trackBundle(props.productId)
    // alert(`${props.title} has been added to your box!`)
  }
}
</script>

<style>
.bundle-quantity-control {
  height: 44px;

  .plus-minus-button,
  button {
    position: relative;

    /* Expands the tappable area to 48px tall without affecting the visible 44px height */
    &::before {
      content: '';
      position: absolute;
      inset: -2px 0;
    }
  }

  .plus-minus-button {
    width: 44px;
  }
  &.\+large {
    height: 50px;
    .plus-minus-button {
      width: 50px;
    }
  }
}
</style>
